import { makeRequest } from 'cityads-v3/utils/apiUtils';
import { makeRequestWithSmsConfirmation } from './sms';

export const GET_ZALEYCASH_ACCOUNTS = 'zaleycash/GET_ZALEYCASH_ACCOUNTS';
export const GET_ZALEYCASH_ACCOUNTS_SUCCESS = 'zaleycash/GET_ZALEYCASH_ACCOUNTS_SUCCESS';
export const GET_ZALEYCASH_ACCOUNTS_FAIL = 'zaleycash/GET_ZALEYCASH_ACCOUNTS_FAIL';

export const CREATE_ZALEYCASH_ACCOUNT = 'zaleycash/CREATE_ZALEYCASH_ACCOUNT';
export const CREATE_ZALEYCASH_ACCOUNT_SUCCESS = 'zaleycash/CREATE_ZALEYCASH_ACCOUNT_SUCCESS';
export const CREATE_ZALEYCASH_ACCOUNT_FAIL = 'zaleycash/CREATE_ZALEYCASH_ACCOUNT_FAIL';

export const SET_ZALEYCASH_ACCOUNT_CREATION_ERRORS = 'zaleycash/SET_ZALEYCASH_ACCOUNT_CREATION_ERRORS';

export const DELETE_ZALEYCASH_ACCOUNT = 'zaleycash/DELETE_ZALEYCASH_ACCOUNT';
export const DELETE_ZALEYCASH_ACCOUNT_SUCCESS = 'zaleycash/DELETE_ZALEYCASH_ACCOUNT_SUCCESS';
export const DELETE_ZALEYCASH_ACCOUNT_FAIL = 'zaleycash/DELETE_ZALEYCASH_ACCOUNT_FAIL';

export const CLEAN_ZALEYCASH_PAYMENT_PREVIEW = 'zaleycash/CLEAN_ZALEYCASH_PAYMENT_PREVIEW';

export const GET_ZALEYCASH_PAYMENT_PREVIEW = 'zaleycash/GET_ZALEYCASH_PAYMENT_PREVIEW';
export const GET_ZALEYCASH_PAYMENT_PREVIEW_SUCCESS = 'zaleycash/GET_ZALEYCASH_PAYMENT_PREVIEW_SUCCESS';
export const GET_ZALEYCASH_PAYMENT_PREVIEW_FAIL = 'zaleycash/GET_ZALEYCASH_PAYMENT_PREVIEW_FAIL';

export const CREATE_ZALEYCASH_PAYMENT = 'zaleycash/CREATE_ZALEYCASH_PAYMENT';
export const CREATE_ZALEYCASH_PAYMENT_SUCCESS = 'zaleycash/CREATE_ZALEYCASH_PAYMENT_SUCCESS';
export const CREATE_ZALEYCASH_PAYMENT_FAIL = 'zaleycash/CREATE_ZALEYCASH_PAYMENT_FAIL';

export function getZaleyCashAccounts() {
  return makeRequest(`/saduka/zaleyCashAccounts`, {
    types: [GET_ZALEYCASH_ACCOUNTS, GET_ZALEYCASH_ACCOUNTS_SUCCESS, GET_ZALEYCASH_ACCOUNTS_FAIL],
    options: {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'GET',
    },
  });
}

export function createZaleyCashAccount(data) {
  return makeRequestWithSmsConfirmation(
    `/saduka/zaleyCashAccounts`,
    { externalAccount: data },
    {
      types: [CREATE_ZALEYCASH_ACCOUNT, CREATE_ZALEYCASH_ACCOUNT_SUCCESS, CREATE_ZALEYCASH_ACCOUNT_FAIL],
    }
  );
}

export function setZaleyCashAccountCreationErrors(errors) {
  return {
    type: SET_ZALEYCASH_ACCOUNT_CREATION_ERRORS,
    errors,
  };
}

export function deleteZaleyCashAccount(accountId) {
  return makeRequest(`/saduka/zaleyCashAccounts/${encodeURIComponent(accountId)}`, {
    types: [DELETE_ZALEYCASH_ACCOUNT, DELETE_ZALEYCASH_ACCOUNT_SUCCESS, DELETE_ZALEYCASH_ACCOUNT_FAIL],
    options: {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'DELETE',
    },
    accountId,
  });
}

export function cleanZaleyCashPaymentPreview(accountId) {
  return {
    type: CLEAN_ZALEYCASH_PAYMENT_PREVIEW,
    accountId,
  };
}

export function getZaleyCashPaymentPreview(accountId, amount, conversionDate) {
  return makeRequest(`/saduka/zaleyCashAccounts/paymentPreview `, {
    types: [GET_ZALEYCASH_PAYMENT_PREVIEW, GET_ZALEYCASH_PAYMENT_PREVIEW_SUCCESS, GET_ZALEYCASH_PAYMENT_PREVIEW_FAIL],
    options: {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({
        accountId,
        amount,
        conversionDate: conversionDate.toISOString(),
      }),
    },
    accountId,
    amount,
    conversionDate,
  });
}

export function createZaleyCashPayment(accountId, amount) {
  return makeRequestWithSmsConfirmation(
    `/saduka/zaleyCashAccounts/payment`,
    { accountId, amount },
    {
      types: [CREATE_ZALEYCASH_PAYMENT, CREATE_ZALEYCASH_PAYMENT_SUCCESS, CREATE_ZALEYCASH_PAYMENT_FAIL],
    }
  );
}
